import { Tile } from 'common/tile/tile.js';
import { IModule } from 'redux-state/layout/types.js';

/**
 * Empty is a module that is used as a space filler, since the layouts are setup in a way where
 * if a slot doesn't contain any modules, then the other slot next to it will take over that space.
 * This module is used to prevent this takeover for modules that don't look correct taking up the entire layout.
 */
const Empty = (props: IModule) => (
  <Tile dataModule="empty-module" {...props}>
    {[]}
  </Tile>
);

export { Empty };
